export default (phone) => {
  if (phone) {
    const splittedPhone = phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    return !splittedPhone[2] ? splittedPhone[1] : '(' + splittedPhone[1] + ')' + '-' + splittedPhone[2] + (splittedPhone[3] ? '-' + splittedPhone[3] : '');
  }
  return '';
}
